import React from 'react'

export default function SelectPaperSizeFormStyle() {
  return (
    <style jsx='true'>
    {`
      /* Header Style */
      .select-papersize-header {
        display: flex;
        width: 100%;
      }
      .spsh { flex: 2; }

      .option-buttons-container {
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 10px;
      }
      .selection {
        background-color: white;
        border: solid 1px lightgrey;
        padding: 30px 10px;
      }
      .selection:hover, .selection:focus {
        cursor: pointer;
        box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2), 0 7px 20px 0 rgba(0, 0, 0, 0.2);
        transform: scale(1.02);
        outline: none;
      }
    `}
    </style>
  )
}